import React, { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import PremiumHeader from "../components/ui/PremiumHeader";
import MembershipStatsCard from "../components/ui/MembershipStatsCard";
import RankingItem from "../components/ui/RankingItem";
import MemberChartModal from "../components/modals/MemberChartModal";
import { useRankings } from "../hooks";
import { useMypageContext } from "../context/MypageContext";
import { RankingUser } from "../types";

interface RankingViewProps {
  onNotificationClick: () => void;
}

const RankingView: React.FC<RankingViewProps> = ({ onNotificationClick }) => {
  const { rankings, isLoading, error } = useRankings();
  const { mypage, refresh } = useMypageContext();
  const [selectedUser, setSelectedUser] = useState<RankingUser | null>(null);

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex flex-col h-full animate-in fade-in duration-300 overflow-hidden">
      <PremiumHeader
        title="ランキング"
        icon={Trophy}
        theme="blue"
        onNotificationClick={onNotificationClick}
      />
      <div className="px-6 py-6 pb-40 overflow-y-auto scrollbar-hide text-left flex-1">
        <MembershipStatsCard
          points={mypage?.yearly_point ?? "-"}
          rank={mypage?.yearly_rank ?? "-"}
          loginId={mypage?.login_id}
          dartsliveName={mypage?.dartslive_card_name}
          eventGroupName={mypage?.event_group?.name}
          theme="blue"
        />
        <div className="mb-5 pl-1 flex items-center gap-2">
          <h2 className="text-[11px] font-black text-slate-400 uppercase tracking-widest text-left">
            年間ランキング
          </h2>
          {mypage?.event_group?.name && (
            <span className="text-[10px] font-bold text-blue-600 bg-blue-50 border border-blue-100 rounded-full px-2 py-0.5">
              {mypage.event_group.name}
            </span>
          )}
        </div>
        {isLoading && (
          <p className="text-slate-400 text-xs font-bold text-center py-8">
            読み込み中...
          </p>
        )}
        {error && (
          <p className="text-rose-500 text-xs font-bold text-center py-8">
            {error}
          </p>
        )}
        <div className="space-y-1 text-left">
          {rankings.map((user) => (
            <RankingItem
              key={user.rank}
              {...user}
              onClick={() => setSelectedUser(user)}
            />
          ))}
        </div>
      </div>

      <MemberChartModal
        isOpen={selectedUser !== null}
        onClose={() => setSelectedUser(null)}
        selectedUser={selectedUser}
        rankings={rankings}
      />
    </div>
  );
};

export default RankingView;
